import { createAction } from '@reduxjs/toolkit'

export const updateQuery = createAction('clientSetting/updateQuery')

export const updateIsTryAnotherTextVisible = createAction(
  'clientSetting/updateIsTryAnotherTextVisible'
)

export const updateArtisticStyle = createAction(
  'clientSetting/updateArtisticStyle'
)

export const updateSpace = createAction('clientSetting/updateSpace')

export const updateRecommendation = createAction(
  'clientSetting/updateRecommendation'
)

export const setErrorMessage = createAction('clientSetting/setErrorMessage')

export const setResultCleared = createAction('clientSetting/setResultCleared')

export const setIsNotificationVisible = createAction(
  'clientSetting/setIsNotificationVisible'
)
